class Slide
{
    /**
     * Constructor
     */
    constructor( options )
    {
        this.root = document.querySelector('.slider');
        this.item = document.querySelectorAll('.slider__item');
        this.contain = document.querySelectorAll('.slider__container');
        this.mover = document.querySelector('.slider__mover');
        this.last = this.contain[this.contain.length -1];
        this.translate = 0;
        this.windows = window.innerWidth;
    }
    size() {
      let count = this.item.length;
      let theSize = 100 / count;
      for (let index = 0; index < this.item.length; index++) {
        this.item[index].style.width = theSize + '%';         
      }
    }
    autoSlide() {
      let that = this;
      let end = this.last.offsetLeft + this.last.offsetWidth;
      let returns = false;
      let pause = false;
      let auto = setInterval(function(){
        if (pause === false)
        {
          if(that.translate >= end) {
            that.mover.style.transform="translateX(100vw)"
            that.translate = 0;
            returns = true;
          } 
          else if(that.windows === 0){
            returns = false;
            that.windows = window.innerWidth;
          }
          if(returns === true) {
            that.return();
            that.windows -= 1;
          }
          else {
            that.slide(); 
            that.translate += 1;
          }
        }
      }, 10);
      for(var i = 0; i < that.contain.length; i++) {
        that.contain[i].onmouseenter = function(){
          pause = true;
         };
         that.contain[i].onmouseleave = function(){
          pause = false;
         };
      }
    }
    slide() {
      this.mover.style.transform="translateX(-"+ this.translate +"px)"
    }
    return() {
      this.mover.style.transform="translateX(+"+ this.windows +"px)"
    }
    init ()
    {
      if (this.root)
      {
        this.autoSlide()
      }
    }
}

export default Slide
